import React, { useState } from 'react';
import RecipeCard from './RecipeCard';
import './RecipeList.css';

const RecipeList = ({ recipes, setRecipes, canEdit = false }) => {
    const [isEditing, setIsEditing] = useState(false);

    const removeRecipe = (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this recipe?");
        if (confirmDelete) {
            setRecipes(prev => prev.filter(recipe => recipe._id !== id));
        }
    };

    return (
        <div className="recipe-card-list">
            {recipes.map(recipe => (
                !recipe ? null : (
                    <div key={recipe._id} className="recipe-card-ex">
                        <RecipeCard recipe={recipe} />
                        {isEditing && (
                            <button className="delete-button" onClick={
                                () => removeRecipe(recipe._id) 
                            }>X</button>
                        )}
                    </div>
                )
            ))}
            {canEdit && (
                <button className="edit-button" onClick={() => setIsEditing(prev => !prev)}>
                    {isEditing ? "Done" : "Edit"}
                </button>
            )}
        </div>
    );
};

export default RecipeList;
